// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"126":"b1613408","679":"1d47a4bd","871":"2d8f279a","883":"4db63733"}[chunkId] + ".js";
};